export const initFieldState = {
  value: '',
  isError: false,
};
